import React from 'react';

const Social = () => {
    return (
        <div className='mt-20 pb-5'>
            <h2 className='text-xl font-bold'>My Social Links</h2>
            <div style={{ height: '1px' }} className='bg-gray-100 w-1/2 mx-auto'></div>
            <div className='flex justify-center mt-3 text-yellow-500'>
                <p className='font-semibold'><a href="">Twitter</a></p>
                <p className='font-bold mx-3'>|</p>
                <p className='font-semibold'><a target='_blank' href="https://www.linkedin.com/in/fazri-islam-84829a241/">Linkedin</a></p>
                <p className='font-bold mx-3'>|</p>
                <p className='font-semibold'><a target='_blank' href="https://github.com/fazriislam">GitHub</a></p>
            </div>
            <div>
                <p><strong>E-mail: </strong>fazriislam111@gmail.com</p>
                <p><strong>Phone: </strong>01533375382</p>
            </div>
        </div>
    );
};

export default Social;